/* Rebuy PDP widgets on the grid product template (loaded by the Custom Liquid block under the Rebuy blocks).
   Add-ons (moved under the Add to Cart form, ticked totals added to the ATC label):
   313260 = Mystery Necklace add-on, 314465 = Black Friday VIP Pass add-on ($1, BFCM 2026).
   Styles for the add-ons + 302597 live in rebuy-pdp-widgets.css. */
(function () {
  var ADDONS = ['313260', '314465'];
  var label, defaultText, baseCents = null, written = null, queued = false, observer = null;

  function column() { return document.querySelector('.product_info_column'); }
  function atcForm() { var col = column(); return col && col.querySelector('form[id^="AddToCartForm-"]'); }

  // The ATC Form block also renders icons, countdown, upsell and accordions, so app blocks placed
  // after it land below the accordions. Move the add-on to sit directly under the Add to Cart form.
  function moveAddon() {
    var col = column(), form = atcForm();
    var anchor = form && form.closest('.product_info_column > *');
    if (!col || !anchor) return;
    ADDONS.forEach(function (id) {
      var holder = col.querySelector('[data-rebuy-id="' + id + '"]');
      var host = holder && holder.closest('.shopify-app-block');
      if (!host) return;
      if (anchor.nextElementSibling !== host) anchor.after(host);
      anchor = host;
    });
  }

  // "$48", "$1,048.50", "48,00 €" -> cents
  function toCents(text) {
    var match = String(text || '').match(/\d[\d.,\s]*/);
    if (!match) return null;
    var num = match[0].replace(/\s/g, '').replace(/[.,]$/, '');
    var dec = num.match(/[.,](\d{1,2})$/);
    var whole = (dec ? num.slice(0, -dec[0].length) : num).replace(/[.,]/g, '');
    return parseInt(whole, 10) * 100 + (dec ? parseInt((dec[1] + '0').slice(0, 2), 10) : 0);
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return '$' + Math.round(cents / 100);
  }

  // Rebuy only renders the add-on subtotal while at least one row is ticked.
  function addonCents() {
    return ADDONS.reduce(function (sum, id) {
      // Discounted add-ons show a .sale price; full-price ones (the $1 pass) only a plain .rebuy-money.
      var box = document.querySelector('#rebuy-widget-' + id + ' .rebuy-addon__subtotal-value');
      var value = box && (box.querySelector('.rebuy-money.sale') || box.querySelector('.rebuy-money'));
      return sum + (value ? toCents(value.textContent) || 0 : 0);
    }, 0);
  }

  function inAddon(el) {
    return ADDONS.some(function (id) {
      return el.closest('[data-rebuy-id="' + id + '"]') || (el.querySelector && el.querySelector('[data-rebuy-id="' + id + '"]'));
    });
  }

  // Rebuy adds ticked add-ons together with the main Add to Cart, so the label shows the combined price.
  function syncLabel() {
    queued = false;
    if (!label) return;
    var text = label.textContent.trim();
    var prefix = defaultText + ' - ';
    if (text !== written) {
      // The theme (re)wrote the label after a variant or quantity change, or it shows "Sold out".
      baseCents = text.indexOf(prefix) === 0 ? toCents(text.slice(prefix.length)) : null;
    }
    if (baseCents === null) return;
    var next = prefix + formatMoney(baseCents + addonCents());
    if (next !== text) {
      written = next;
      label.textContent = next;
    }
  }

  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(syncLabel);
  }

  // Rebuy re-renders (and can replace) its own nodes, so watch the stable product column and react only
  // to changes in the ATC label or inside the add-on widget.
  function relevant(records) {
    for (var i = 0; i < records.length; i++) {
      var node = records[i].target;
      var el = node.nodeType === 1 ? node : node.parentElement;
      if (!el) continue;
      if (label.contains(el) || inAddon(el)) return true;
    }
    return false;
  }

  function init() {
    moveAddon();
    var col = column(), form = atcForm();
    label = form && form.querySelector('[id^="AddToCartText-"]');
    if (!col || !label) return;
    defaultText = label.getAttribute('data-default-text') || 'Add to cart';
    written = null;
    if (observer) observer.disconnect();
    // Add-on widgets can arrive after this runs, so keep them under the form whenever the column changes
    // (moveAddon only moves a widget that is out of place, so it can't loop).
    observer = new MutationObserver(function (records) {
      moveAddon();
      if (relevant(records)) queueSync();
    });
    observer.observe(col, { childList: true, characterData: true, subtree: true });
    queueSync();
    [400, 1500, 4000].forEach(function (ms) { setTimeout(moveAddon, ms); });
  }

  // VIP Pass add-on: Rebuy renders its image and title as plain elements (no quick view), so make them open
  // the pass page in a new tab; the rest of the row still ticks the checkbox.
  var PASS_ADDON = '314465', PASS_URL = '/products/early-access-pass';
  document.addEventListener('click', function (e) {
    var target = e.target.closest && e.target.closest('#rebuy-widget-' + PASS_ADDON + ' .rebuy-addon__item-image, #rebuy-widget-' + PASS_ADDON + ' .rebuy-addon__item-product-title');
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    window.open(PASS_URL, '_blank', 'noopener');
  }, true);

  // Fallback: Rebuy updates its subtotal a tick after the checkbox changes.
  document.addEventListener('change', function (e) {
    if (e.target.closest && ADDONS.some(function (id) { return e.target.closest('#rebuy-widget-' + id); })) {
      setTimeout(queueSync, 60);
      setTimeout(queueSync, 300);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
